import {put, takeEvery} from "redux-saga/effects";
import {Item} from "../../../Models/Item";
import {fillItems} from "../../utils";
import {
    itemCreateError,
    itemCreateSuccess,
    itemLoadError,
    itemLoadSuccess,
    itemsGetError,
    itemsGetSuccess,
    itemUpdateError,
    itemUpdateSuccess,
} from "./actions";
import * as TYPES from "./types";

export default function* itemsSagas() {
    yield takeEvery(TYPES.ITEMS_GET_REQUEST, itemsGetRequest);
    yield takeEvery(TYPES.ITEM_LOAD_REQUEST, itemLoadRequest);
    yield takeEvery(TYPES.ITEM_CREATE_REQUEST, itemCreateRequest);
    yield takeEvery(TYPES.ITEM_UPDATE_REQUEST, itemUpdateRequest);
}

function* itemsGetRequest(action) {
    try {
        const response = yield Item.index({
            ...action.payload,
        });

        yield put(
            itemsGetSuccess({
                ...fillItems(response, Item),
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemsGetError(error));
    }
}

function* itemLoadRequest(action) {
    try {
        const response = yield Item.find(action.payload);

        yield put(
            itemLoadSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemLoadError(error));
    }
}

function* itemCreateRequest(action) {
    try {
        const response = yield Item.create(action.payload);

        yield put(
            itemCreateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemCreateError(error));
    }
}

function* itemUpdateRequest(action) {
    try {
        const response = yield Item.update(action.payload.id, action.payload);

        yield put(
            itemUpdateSuccess({
                ...response,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(itemUpdateError(error));
    }
}
